import {JobDescription} from "../../../../../filters/JobDescription";
import {Button, Divider, Form, Input, message} from "antd";
import React from "react";
import {ScopePost, ScopeUpdate} from "../../../../../models/crm/scope";

const FormItem = Form.Item;
const {TextArea} = Input;


class JobScopeForm extends React.Component {
    state = {
        data: null,
        update: false,
        btn_text: 'Add Job Scope'
    };
    handleJobDescriptionChange = (value) => {
        this.props.form.setFieldsValue({
            job_description: value,
        });
    };

    handleSubmitScope = () => {
        const {data} = this.state;
        this.props.form.validateFields((err, values) => {
            if (!err) {
                if (data)
                    ScopeUpdate(data.id, values)
                        .then(response => {
                            this.props.onChange(response.id);
                            this.setState({data: response, update: false});
                            message.success("Job Scope updated successfully");
                            this.resetFields()
                        });
                else
                    ScopePost(values)
                        .then(response => {
                            this.props.onChange(response.id);
                            this.setState({data: response, update: false});
                            message.success("Job Scope added successfully");
                            this.resetFields()
                        })
            }
        })
    };

    resetFields = () => {
        this.props.form.resetFields();
        this.choose_description.handleChange()
    };

    fillUpdateFields = () => {
        const {data} = this.state;
        this.props.form.setFieldsValue({
            job_description: data.job_description
        });
        this.setState({update: true, btn_text: "Update Job Scope"})
    };

    render() {
        const {getFieldDecorator} = this.props.form;
        const {data, update, btn_text} = this.state;
        return (
            <div className="job-scope-tab">
                <div className="row m-0">
                    <div className="col-sm-5 col-12">
                        <div className="floating-label">
                            <FormItem label="Choose a template">
                                {getFieldDecorator('choose_description')(<JobDescription
                                    onChange={this.handleJobDescriptionChange}
                                    onRef={ref => (this.choose_description = ref)}/>)}
                            </FormItem>
                        </div>
                    </div>
                    <div className="col-sm-1 col-12">
                        <div className="floating-label job-divider padding-0">
                            <Divider>or</Divider>
                        </div>
                    </div>
                    <div className="col-sm-5 col-12">
                        <div className="floating-label">
                            <FormItem label="Enter Job Description">
                                {getFieldDecorator('job_description', {
                                    rules: [{required: true, message: 'Please enter job description'}],
                                })(<TextArea className="job-desc-field" autosize={{minRows: 1, maxRows: 8}}
                                             placeholder="Enter Job Description"/>)}
                            </FormItem>
                        </div>
                    </div>
                    {(!data || update) &&
                    <div className="col-12 add-btn">
                        <Button type="primary" htmlType={"button"} onClick={this.handleSubmitScope}>{btn_text}</Button>
                    </div>}
                </div>
                {data &&
                <div className="added-serv-record">
                    <div className="row m-0">
                        <div className="col-12 added-jd added-service-info">
                            <Button className="edit-gen-btn" onClick={this.fillUpdateFields}><i
                                className="fa fa-pencil"/></Button>
                            <h6>Added Job Description</h6>
                            <p>{data.job_description}</p>
                        </div>
                    </div>
                </div>}
            </div>
        )
    }
}

export const JobScope = Form.create()(JobScopeForm);



// WEBPACK FOOTER //
// ./src/pages/crm/proposals/popups/tabs/JobScope.jsx